import { LoadingButton } from "@mui/lab";
import { Button, DialogActions } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../context";
import { useRestoreTheme } from "./service/useRestoreTheme";

export default function DialogFooter() {
	const { actions } = useContext(Context);
	const { translate } = useLocales();

	const { isLoading, onSaveTheme } = useRestoreTheme();

	const onClick = () => {
		onSaveTheme();
	};

	return (
		<DialogActions>
			<Button
				color='inherit'
				disabled={false}
				onClick={actions.hideRestoreDialog}
				variant='outlined'
			>
				{translate("customization.cancel")}
			</Button>
			<LoadingButton loading={isLoading} onClick={onClick} variant='contained' color='error'>
				{translate("customization.confirm")}
			</LoadingButton>
		</DialogActions>
	);
}
